// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { FieldValueResponse } from './field-value-response';

// @ts-ignore
import { FormComponentResponse } from './form-component-response';

// @ts-ignore
import { FormPositionResponse } from './form-position-response';

/** See com.rev360.pms.api.controller.encounter.dynamic.DynamicTestResponse */
/* istanbul ignore next */
@GandalfModel
export class DynamicTestResponse extends GandalfModelBase {

	@GandalfArray(FormComponentResponse)
	children!: FormComponentResponse[] | null;

	@GandalfProperty({ designType: String })
	comment!: string | null;

	@GandalfProperty({ designType: Number })
	fileCount!: number | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ designType: Boolean })
	isReadOnly!: boolean | null;

	@GandalfProperty({ designType: Boolean })
	isServerCopyDirty!: boolean | null;

	@GandalfProperty({ designType: String })
	name!: string | null;

	@GandalfProperty({ designType: FormPositionResponse })
	position!: FormPositionResponse | null;

	@GandalfProperty({ designType: Number })
	testMasterId!: number | null;

	@GandalfProperty({ designType: Number })
	testTemplateId!: number | null;

	@GandalfProperty({ designType: Boolean })
	useRefractionFields!: boolean | null;

	@GandalfArray(FieldValueResponse)
	values!: FieldValueResponse[] | null;

	@GandalfProperty({ designType: Number })
	version!: number | null;

}
